<template>
  <div class="main">
    <c-panel>
      <form-cotacao :paramId="$route.params.id" v-on:onSubmitCotacao="onSubmitCotacao"></form-cotacao>
    </c-panel>
  </div>
</template>
<script>
import formCotacao from "./form"

export default {
  methods: {
    onSubmitCotacao () {
      this.$router.push('/admin/financeiro/cotacao')
    }
  },
  components: { formCotacao }
}
</script>

